import React from 'react';

import { LbBigModal } from '../../../../../shared/components/modals';
import { InfoBlock } from './InfoBlock/InfoBlock';

type SelfBillingPaymentRolesModalProps = {
  open: boolean;
  onClose: () => void;
};

const SelfBillingPaymentRulesModal = ({
  open,
  onClose,
}: SelfBillingPaymentRolesModalProps) => {
  return (
    <LbBigModal
      open={open}
      title="Payment Rules"
      onClose={onClose}
      buttonOptions={{
        noText: 'Close',
        noHandler: onClose,
        yesVisible: false,
      }}
    >
      <InfoBlock
        title="Payment Date"
        descriptions={[
          'Payment is processed monthly on the date the Entity was created. This is typically within 48 hours of the date of registration.',
        ]}
        note="Note: If the billing date falls on the 31st, the entity will be billed on the last day of any month ending in 28, 29, or 30 days."
      />
      <InfoBlock
        title="Late Payment"
        descriptions={[
          'If payment is not successfully made on time, the Entity and Coaches will be restricted from accessing their dashboards.',
          'Access can be restored by making a successful payment for all past due invoices.',
        ]}
      />
      <InfoBlock
        title="Customer Access"
        descriptions={[
          'Customers keep access to the mobile app even if an Entity payment fails.',
          "Access is only restricted if the Super Admin, Entity, or Coach manually cancels the subscription in the “Payment” tab on a Customer's profile.",
        ]}
        note="Note: A Customer will still have access to the mobile app until the end of their subscription, even if it is cancelled. This is because they pay in advance for access to the app."
      />
    </LbBigModal>
  );
};

export { SelfBillingPaymentRulesModal };
